import { BehaviorDefinition } from "views/knowledge/components/card";
import { PollCardDefinitions } from "views/knowledge/components/card/behaviors/poll";
import { PostCardDefinitions } from "views/knowledge/components/card/behaviors/post";
import { ListCardDefinitions } from "views/knowledge/components/card/behaviors/list";
import { QuestionCardDefinitions } from "views/knowledge/components/card/behaviors/question";
import { AnswerCardDefinitions } from "views/knowledge/components/card/behaviors/answer";

/**
 * Tabela Completa de Definições para montagem dos Cards
 **/
export const PublicationCardDefinitions: Array<BehaviorDefinition> = [
    ...PostCardDefinitions,
    ...PollCardDefinitions,
    ...ListCardDefinitions,
    ...QuestionCardDefinitions,
    ...AnswerCardDefinitions
];
